module.exports = __webpack_public_path__ + "media/images/emblems/Bassersdorf-blazon-bb5a062599435b100e7c9dd8b6f92f07.svg";